import { AppGrid } from "../components/AppGrid";
import { AppsCenterLayout } from "../layout/AppsCenterLayout";

export const AppsCenterPage = () => {
  return (
    <AppsCenterLayout>
      <AppGrid />
    </AppsCenterLayout>
  );
};
